import { Component } from '@angular/core';
import { LandingToolbarComponent } from '../landing-toolbar/landing-toolbar.component';
import { LandingFooterComponent } from '../landing-footer/landing-footer.component';

@Component({
  selector: 'app-terms-conditions',
  standalone: true,
  imports: [
    LandingToolbarComponent,
    LandingFooterComponent
  ],
  templateUrl: './terms-conditions.component.html',
  styleUrls: ['./terms-conditions.component.scss', '../../../app.component.scss']
})
export class TermsConditionsComponent {

  mail: String = 'pqrs@workbiservices.com';

}
